module.exports = __webpack_public_path__ + "static/media/41.6181708b.png";